module.exports = __webpack_public_path__ + "img/img2.8406fccf.png";